import { CreateCanvaDesignModal } from './CreateCanvaDesignModal'

export default CreateCanvaDesignModal
